import { render, staticRenderFns } from "./SellingReportMaterial.vue?vue&type=template&id=6330d2b6&scoped=true"
import script from "./SellingReportMaterial.vue?vue&type=script&lang=js"
export * from "./SellingReportMaterial.vue?vue&type=script&lang=js"
import style0 from "./SellingReportMaterial.vue?vue&type=style&index=0&id=6330d2b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6330d2b6",
  null
  
)

export default component.exports